import { useContext } from "react";
import { I18nContext } from "../../i18n/useI18n";
import PrincipalBanner from "../../contents/PrincipalBanner";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";
import Collapse from "../../components/Collapse";

const projectDescriptionContent = "pages.project.description";

const Page = () => {
  const { t } = useContext(I18nContext);
  return (
    <main className="mx-auto my-0 max-w-7xl font-nunito text-2xl">
      <PrincipalBanner
        bgColor="grape"
        bgHero="https://static.igem.wiki/teams/5058/imgs/project-description-v3-min.svg"
      >
        <h1 className="invisible">{t(`${projectDescriptionContent}.title`)}</h1>
      </PrincipalBanner>

      <section className="px-6 py-8">
        <h2
          className={twMerge(
            "bg-grape mb-7 px-8 py-3 pt-[18px] rounded-badge w-fit font-bold font-josefin text-3xl text-center text-secondary uppercase leading-9"
          )}
        >
          {t(`${projectDescriptionContent}.introduction.title`)}
        </h2>
        <p className="font-bold font-manjari text-3xl leading-9">
          {t(`${projectDescriptionContent}.introduction.text`)}
        </p>
      </section>
      <section className="min-h-80">
        <h2
          className={twMerge(
            clsx("font-bold font-nunito text-4xl text-secondary")
          )}
        >
          {t(`${projectDescriptionContent}.inspiration.title`)}
        </h2>
        <p>
          <img
            className="inline-block float-right m-0 -mt-10 ml-auto w-1/4"
            src="https://static.igem.wiki/teams/5058/imgs/mundo-morrendo-project.svg"
            alt=""
          />
          {t(`${projectDescriptionContent}.inspiration.text`)}
        </p>
      </section>
      <section className="px-6 py-8">
        <h2
          className={twMerge(
            clsx(
              "font-bold font-nunito text-4xl text-secondary",
              "text-right ml-auto"
            )
          )}
        >
          {t(`${projectDescriptionContent}.howandwhy.title`)}
        </h2>
        <p className="pb-1">
          {t(`${projectDescriptionContent}.howandwhy.text1`)}
        </p>
        <p className="py-1">
          <img
            className="mx-auto my-3 w-full max-w-2xl"
            src="https://static.igem.wiki/teams/5058/imgs/esquema-project.svg"
            alt="project schema"
          />
          <small className="block w-full text-center invisible">
            {t(`${projectDescriptionContent}.howandwhy.legend-project-schema`)}
          </small>
        </p>
        <p className="py-1">
          {t(`${projectDescriptionContent}.howandwhy.text2`)}
        </p>
        <p className="py-1">
          <img
            className="mx-auto my-3 w-full max-w-4xl"
            src="https://static.igem.wiki/teams/5058/imgs/via-de-nad-project-v2.svg"
            alt="NAD+ pathway"
          />
          <small className="block w-full text-center invisible">
            {t(`${projectDescriptionContent}.howandwhy.legend-nad`)}
          </small>
        </p>
        <p className="py-1">
          {t(`${projectDescriptionContent}.howandwhy.text3`)}
        </p>
      </section>
      <section className="px-6 py-8">
        <h2
          className={twMerge(
            clsx("font-bold font-nunito text-4xl text-secondary")
          )}
        >
          {t(`${projectDescriptionContent}.syntheticBiology.title`)}
        </h2>

        <article className="font-nunito text-2xl">
          <h3
            className={twMerge(
              clsx("mt-5 mb-1 py-3 w-fit font-manjari text-5xl")
            )}
          >
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.yob3.title`
            )}
          </h3>

          <p>
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.yob3.description`
            )}
          </p>
        </article>

        <article className="font-nunito text-2xl">
          <h3
            className={twMerge(
              clsx("mt-5 mb-1 py-3 w-fit font-manjari text-5xl")
            )}
          >
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.fba.title`
            )}
          </h3>
          <p>
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.fba.description`
            )}
          </p>
        </article>

        <article className="font-nunito text-2xl">
          <h3
            className={twMerge(
              clsx("mt-5 mb-1 py-3 w-fit font-manjari text-5xl")
            )}
          >
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.genemanipulation.title`
            )}
          </h3>
          <p>
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.genemanipulation.description`
            )}
          </p>
          <p className="flex flex-row justify-around">
            <img
              className="mx-auto w-1/2 max-w-lg"
              src="https://static.igem.wiki/teams/5058/imgs/gif-transporte-de-nad.gif"
              alt="NAD+ transport"
            />
            <img
              className="mx-auto w-1/2 max-w-lg"
              src="https://static.igem.wiki/teams/5058/imgs/gif-transporte-nr-membrana.gif"
              alt="NR transport"
            />
          </p>
        </article>

        <article className="font-nunito text-2xl">
          <h3
            className={twMerge(
              clsx("mt-5 mb-1 py-3 w-fit font-manjari text-5xl")
            )}
          >
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.degron.title`
            )}
          </h3>
          <p>
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.degron.description`
            )}
          </p>
          <p className="py-1">
            <img
              className="mx-auto my-3 w-full max-w-4xl"
              src="https://static.igem.wiki/teams/5058/gif-auxina.gif"
              alt="NAD+ pathway"
            />
            <small className="block w-full text-center invisible">
              {t(`${projectDescriptionContent}.howandwhy.legend-nad`)}
            </small>
          </p>
        </article>

        <article className="font-nunito text-2xl">
          <h3
            className={twMerge(
              clsx("mt-5 mb-1 py-3 w-fit font-manjari text-5xl")
            )}
          >
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.plants.title`
            )}
          </h3>
          <p>
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.plants.description`
            )}
          </p>
        </article>
        <article className="font-nunito text-2xl">
          <h3
            className={twMerge(
              clsx("mt-5 mb-1 py-3 w-fit font-manjari text-5xl")
            )}
          >
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.productivity.title`
            )}
          </h3>
          <p>
            {t(
              `${projectDescriptionContent}.syntheticBiology.categories.mainSteps.categories.productivity.description`
            )}
          </p>
        </article>
      </section>
      <section className="px-6 py-8">
        <h2
          className={twMerge(
            clsx(
              "font-bold font-nunito text-4xl text-secondary",
              "text-right ml-auto"
            )
          )}
        >
          {t(`${projectDescriptionContent}.conclusion.title`)}
        </h2>
        <article className="font-nunito text-2xl">
          <p>{t(`${projectDescriptionContent}.conclusion.text`)}</p>
        </article>
      </section>
      <section className="px-6 py-8">
        <Collapse>
          <Collapse.Title>
            {t(`${projectDescriptionContent}.references.title`)}
          </Collapse.Title>
          <Collapse.Content>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text2`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text3`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text4`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text5`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text6`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text7`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text8`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text9`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text10`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text11`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text12`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text13`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text14`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text15`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text16`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text17`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text18`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text19`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text20`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text21`)}
            </p>
            <p className="py-2">
              {t(`${projectDescriptionContent}.references.text22`)}
            </p>
            <p className="py-5"></p>
          </Collapse.Content>
        </Collapse>
      </section>
    </main>
  );
};
export default Page;
